import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Trending from './components/Trending';
import Gallery from './components/Gallery';
import Jokes from './components/Jokes';
import About from './components/About';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import JsonLd from './components/JsonLd';
import { faqs } from '@/mocks/memes';

const BASE = 'https://jxzuche.cn';

const schema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '每日看瓜',
    url: BASE,
    description: '每日看瓜 - 热门事件表情包、梗图、段子与神评论的在线仓库',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '每日看瓜 - 表情包合集 · 梗图 · 段子 · 神评论',
    url: BASE,
    description: '每日看瓜表情包合集、每日看瓜梗图段子神评论、每日看瓜网友二创的在线仓库。',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '每日看瓜 - 每日看瓜表情包合集 · 梗图段子神评论',
    url: `${BASE}/`,
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={schema} />
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <Gallery />
        <Jokes />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}